export const CONTACTS_LOCAL_API_REQUESTS = false;
